import React from 'react';
import { useEffect } from 'react';
export const GoogleAdNew = () => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error("AdSense push failed", e);
        }
    }, [])

    return (
        <ins className="adsbygoogle"
            style={{ display: "inline-block",width:"728px",height:"90px" }}
            data-ad-client="ca-pub-6898148057618290"
            data-ad-slot="4087760498"></ins>
    );
}